import { ValueUpdater } from '../../../../valueUpdater';
import { DefectV11 } from './defectV11';
import { FlatRateUnitV11 } from './flatRateUnitV11';
import { PartV11 } from './partV11';
export class PackageV11 {
    static constructFromPlainObject(sourcePackage) {
        const defects = sourcePackage.defects
            ? sourcePackage.defects.map((d) => DefectV11.constructFromPlainObject(d))
            : sourcePackage.defects;
        const flatRateUnits = sourcePackage.flatRateUnits
            ? sourcePackage.flatRateUnits.map((f) => FlatRateUnitV11.constructFromPlainObject(f))
            : sourcePackage.flatRateUnits;
        const parts = sourcePackage.parts
            ? sourcePackage.parts.map((p) => PartV11.constructFromPlainObject(p))
            : sourcePackage.parts;
        const servicePackage = new PackageV11(sourcePackage.number, sourcePackage.description, sourcePackage.type);
        servicePackage.positionNumber = ValueUpdater.updateNullableNumber(servicePackage.positionNumber, sourcePackage.positionNumber);
        servicePackage.campaignBegin = ValueUpdater.updateNullableField(servicePackage.campaignBegin, sourcePackage.campaignBegin);
        servicePackage.campaignEnd = ValueUpdater.updateNullableField(servicePackage.campaignEnd, sourcePackage.campaignEnd);
        servicePackage.campaignName = ValueUpdater.updateNonNullableString(servicePackage.campaignName, sourcePackage.campaignName);
        servicePackage.campaignNumber = ValueUpdater.updateNonNullableString(servicePackage.campaignNumber, sourcePackage.campaignNumber);
        servicePackage.defects = ValueUpdater.updateNonNullableField(servicePackage.defects, defects);
        servicePackage.flatRateUnits = ValueUpdater.updateNonNullableField(servicePackage.flatRateUnits, flatRateUnits);
        servicePackage.parts = ValueUpdater.updateNonNullableField(servicePackage.parts, parts);
        servicePackage.grossPrice = ValueUpdater.updateNullableField(servicePackage.grossPrice, sourcePackage.grossPrice);
        servicePackage.isLocal = ValueUpdater.updateNonNullableBoolean(servicePackage.isLocal, sourcePackage.isLocal);
        servicePackage.isSelected = ValueUpdater.updateNonNullableBoolean(servicePackage.isSelected, sourcePackage.isSelected);
        return servicePackage;
    }
    constructor(number, description, type) {
        this.number = number;
        this.description = description;
        this.type = type;
        this.campaignBegin = null;
        this.campaignEnd = null;
        this.campaignName = '';
        this.campaignNumber = '';
        this.defects = [];
        this.flatRateUnits = [];
        this.grossPrice = null;
        this.isLocal = false;
        this.isSelected = false;
        this.parts = [];
        this.positionNumber = null;
    }
    getCampaignBegin() {
        return this.campaignBegin;
    }
    setCampaignBegin(campaignBegin) {
        this.campaignBegin = campaignBegin;
    }
    getCampaignEnd() {
        return this.campaignEnd;
    }
    setCampaignEnd(campaignEnd) {
        this.campaignEnd = campaignEnd;
    }
    getCampaignName() {
        return this.campaignName;
    }
    setCampaignName(campaignName) {
        this.campaignName = campaignName;
    }
    getCampaignNumber() {
        return this.campaignNumber;
    }
    setCampaignNumber(campaignNumber) {
        this.campaignNumber = campaignNumber;
    }
    getDefects() {
        return this.defects;
    }
    setDefects(defects) {
        this.defects = defects;
    }
    getDescription() {
        return this.description;
    }
    getFlatRateUnits() {
        return this.flatRateUnits;
    }
    setFlatRateUnits(flatRateUnits) {
        this.flatRateUnits = flatRateUnits;
    }
    getNumber() {
        return this.number;
    }
    getParts() {
        return this.parts;
    }
    setParts(parts) {
        this.parts = parts;
    }
    getType() {
        return this.type;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getGrossPrice() {
        return this.grossPrice;
    }
    setGrossPrice(grossPrice) {
        this.grossPrice = grossPrice;
    }
    getIsLocal() {
        return this.isLocal;
    }
    setIsLocal(isLocal) {
        this.isLocal = isLocal;
    }
    getIsSelected() {
        return this.isSelected;
    }
    setIsSelected(isSelected) {
        this.isSelected = isSelected;
    }
}
//# sourceMappingURL=packageV11.js.map